// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"543":"c02c4dd0","638":"5bd99565","720":"0f861725","804":"99eee806"}[chunkId] + ".chunk.js";
};